import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../../../slots/context.js';
import '../../../../../types/product.js';
import { isRxProductAction } from '../../../../../types/typeguards.js';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';

const FramesDeliveryIndicator = ()=>{
    const { Slots  } = useProductDetailSlots();
    const { activeVariant: { sku: activeSku , isExcludedFromCheckout  } ,  } = useProductData();
    const { productAction , selectedOffering  } = useFramesEcommContext();
    const { isDynamicLineItemDeliveryEstimationEnabled  } = useFeatureToggles();
    const deliveryIndicatorSkus = (selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.sku) && !isDynamicLineItemDeliveryEstimationEnabled ? [
        activeSku,
        selectedOffering.sku,
        ...selectedOffering.bundledProductSkus
    ] : [
        activeSku
    ];
    const deliveryItems = deliveryIndicatorSkus.map((sku)=>({
            sku,
            quantity: 1
        })
    );
    return Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: deliveryItems,
        hasRxLens: isRxProductAction(productAction)
    }) : null;
};

export { FramesDeliveryIndicator };
//# sourceMappingURL=FramesDeliveryIndicator.js.map
